import type { ReduxAction } from '@app/types';

export interface UserSettingsState {
  reconnectNumberPerDay: number;
}

const initialUserSettingsState = {
  reconnectNumberPerDay: 3,
};

export function userSettingsReducer(
  state: UserSettingsState = initialUserSettingsState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_RECONNECT_NUMBER_PER_DAY_SUCCEEDED':
    case 'UPDATE_RECONNECT_NUMBER_PER_DAY_SUCCEEDED':
      return { ...state, reconnectNumberPerDay: payload.response.number_per_day };

    case 'FETCH_RECONNECT_NUMBER_PER_DAY_FAILED':
    case 'UPDATE_RECONNECT_NUMBER_PER_DAY_FAILED':
    default:
      return state;
  }
}
